/**
 * Entry Point for Interactive US Map
 * 
 * Renders the map component into the DOM when the page loads.
 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import { USMapSVG } from './components/USMapSVG.jsx';
import { MapErrorBoundary } from './components/MapErrorBoundary.jsx';
import './styles/map.css';

// Initialize the map
function initializeMap() {
  const container = document.getElementById('interactive-us-map-root');
  
  if (container) {
    const root = createRoot(container);
    root.render(
      <MapErrorBoundary>
        <USMapSVG />
      </MapErrorBoundary>
    );
  } else {
    console.warn('Interactive US Map: Container element #interactive-us-map-root not found');
  }
}

// Check if DOM is already loaded, otherwise wait for it
if (document.readyState === 'loading') {
  // DOM is still loading, wait for DOMContentLoaded
  document.addEventListener('DOMContentLoaded', initializeMap);
} else {
  // DOM is already loaded, initialize immediately
  initializeMap();
}
